var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "gray",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-arrow-right-left",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 3 4 4-4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7H4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8 21-4-4 4-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17h16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLeft);
export default __webpack_public_path__ + "static/media/arrow-right-left.5e5dc667be48054819b662d349c7ed73.svg";
export { ForwardRef as ReactComponent };